import { isPlatform } from "@ionic/react";

export const setMobileIsAppLockedState = (isLocked: boolean) => {
  if (isPlatform("cordova")) {
    localStorage.setItem("isAppLocked", isLocked ? "yes" : "");
  } else {
    localStorage.removeItem("isAppLocked");
  }
};
